import React from 'react'

const Loading = () => {
  return <div className='np-loading'><i class="fa fa-spinner fa-spin fa-3x fa-fw"></i></div>
}

export default Loading